import React from 'react'
import { Input } from 'antd'
import { Controller, useFormState } from 'react-hook-form'

// Composant pour le cas isActiveSubmit = true
const ActiveEmailField = ({ field, control }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  const input_style = field.input_design ? { ...field.input_design } : {}
  let inputClass = ''

  if (isSubmitted) {
    inputClass = error ? 'input-error' : 'input-success'
  }

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
      rules={{ required: field.required, pattern: /^\S+@\S+$/i }}
      render={({ field: fieldProps }) => (
        <Input
          className={inputClass}
          style={{ ...input_style }}
          placeholder={field.placeholder || ''}
          {...fieldProps}
        />
      )}
    />
  )
}

// Composant pour le cas isActiveSubmit = false
const InactiveEmailField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}

  return (
    <Input
      defaultValue={field.VALUE__reponse ? field.VALUE__reponse : ''}
      style={{ ...input_style }}
      placeholder={field.placeholder || ''}
    />
  )
}

const EmailField = ({ field, control, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveEmailField field={field} control={control} />
  ) : (
    <InactiveEmailField field={field} />
  )
}

export default EmailField
